<template>
  <div class="gs-app gs-refresh-controls gv-watched-until mb-6">
    <div class="flex flex-row gv-watched-until__row">
      <div class="w-full font-semibold text-sm text-grey-700 mb-1 text-left gv-watched-until__field">
        <label>{{ $t('frontend_groovewebinar_watched_until_time') }}</label>
        <text-input
          style="height: 2rem !important"
          v-model="localModel.minutes"
          :validator="$v.localModel.minutes"
          ></text-input>
          <div v-if="reject" class="error mb-2">
            {{  reject  }}
          </div>
      </div>
      <gs-button
        class="ml-3 mt-5 w-8 h-8 heading-sm focus:outline-none shadow hover:shadow-lg focus:shadow-lg rounded-lg bg-pink hover:bg-pink-dark focus:bg-black text-white border-pink-dark focus:border-black gv-watched-until__add"
        variant="primary"
        size="icon"
        aria-label="Add watched-until point"
        @click="save()">
        +
      </gs-button>
    </div>
  </div>
</template>
<script>
import GdModal from '@groovepages/gd-ui-kit/components/Modal';
import TextInput from '@groovepages/gd-ui-kit/components/TextInput';
import {required} from 'vuelidate/lib/validators';
import WatchedUntil from '@/models/WatchedUntilTime';
export default {
  name: 'watchedUntil',
  components: {
    GdModal,
    TextInput
  },
  props: {
    integration_type:{
      required: true,
      default: 'groovemail'
    },
    video:{
      required: true,
    },
    optinId: {},
    minutes: {
      required: true
    }
  },
  data() {
    return {
      name: '',
      resolve: undefined,
      reject: undefined,
      localModel: {
        minutes: 0,
        video_id: this.video.id,
        optinId: this.optinId,
        integration_type: this.integration_type,
      }
    };
  },
  validations: {
    localModel: {
      minutes: { required },
    }
  },
  methods: {
  //   switchState(value){
  //     //this.name = (value) ? 'disabled' : '';
  //     this.name = value;
  //   },
    async save() {
      if(Number(this.localModel.minutes) > this.minutes) {
        this.showLoader();
        this.$v.localModel.$touch();
        let isValid = !this.$v.localModel.$invalid;
        
        if(isValid && this.localModel.minutes){
          const response = new WatchedUntil(this.localModel);
          const WatchedUntilPoint = await response.for(this.video).save();
          if(WatchedUntilPoint.status === false) {
            this.reject = WatchedUntilPoint.message;
          }else {
            this.$emit('addWatchedUntilPoint', WatchedUntilPoint.data);
            this.$v.localModel.$reset();
            this.reject = undefined;
            this.localModel.minutes = 0;
          }
        }
        this.hideLoader();
      } else {
        this.reject = `Watched Until Time must be atleast ${Number(this.minutes) + 1} minutes`;
      }
    },
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  }
}
</script>
<style lang="scss">
  .error {
    text-align: left;
    color: #ea3d5e;
    margin-top: 0.25rem;
    font-size: 0.875rem;
  }
</style>

<style lang="scss">
  .gv-watched-until__row {
    align-items: flex-start;
    gap: 12px;
  }

  .gv-watched-until__add {
    flex: 0 0 auto;
    min-height: 40px;
    min-width: 40px;
  }

  @media (max-width: 640px) {
    .gv-watched-until__row {
      flex-direction: column;
    }

    .gv-watched-until__add {
      width: 100% !important;
      margin-left: 0 !important;
      margin-top: 0 !important;
    }
  }
</style>
